module.exports = __webpack_public_path__ + "assets/img/page5-first-tab-neutral-71fd9b73.png";